import React, { useMemo } from 'react';
import { useResponsive } from '../../hooks/useResponsive';

interface ResponsiveWrapperProps {
  mobileComponent: React.ComponentType<any>;
  desktopComponent: React.ComponentType<any>;
  tabletComponent?: React.ComponentType<any>;
  breakpoint?: 'md' | 'lg' | 'xl';
  [key: string]: any; // Cho phép truyền props khác
}

const ResponsiveWrapper: React.FC<ResponsiveWrapperProps> = React.memo(({
  mobileComponent: MobileComponent,
  desktopComponent: DesktopComponent,
  tabletComponent: TabletComponent,
  breakpoint = 'md',
  ...props
}) => {
  const { isMobile, isTablet, isDesktop } = useResponsive();

  // Sử dụng useMemo để tránh re-render không cần thiết
  const ComponentToRender = useMemo(() => {
    if (TabletComponent && isTablet) {
      return TabletComponent;
    }
    if (isMobile) {
      return MobileComponent;
    }
    return DesktopComponent;
  }, [isMobile, isTablet, isDesktop, MobileComponent, DesktopComponent, TabletComponent]);

  return <ComponentToRender {...props} />;
});

ResponsiveWrapper.displayName = 'ResponsiveWrapper';

export default ResponsiveWrapper; 